//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"Angle",1,0],[0,"AutomaticOption",1,0],[0,"DeltaXc",1,0],[0,"DeltaYc",1,0],[0,"DirectEngageRetractMode",1,0],[0,"DirectTrimPoint",1,1],[0,"Distance",1,0],[0,"EngageRetractType",1,0],[0,"ExtendDistance",1,0],[0,"ExtendMethod",1,0],[0,"FirstAngle",1,0],[0,"FirstRadius",1,0],[0,"IgnoreWorkpiece",1,0],[0,"Point",1,"Point",0],[0,"Radius",1,0],[0,"SafeDistance",1,0],[0,"SecondAngle",1,0],[0,"SecondRadius",1,0],[0,"TangentialExtension",1,0]],[],[]];
SPLM.CAM.TurnEngageRetractBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.TurnEngageRetractBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.TurnEngageRetractBuilder.Types = Object.freeze({
    "AutoCircular" : "AutoCircular", "AutoLinear" : "AutoLinear", "Delta" : "Delta", "AngleAndDistance" : "AngleAndDistance", "RelativeLinear" : "RelativeLinear", "FromAPoint" : "FromAPoint", "TwoCircles" : "TwoCircles", "TwoPointTangent" : "TwoPointTangent", "Arc" : "Arc", "SameAsEngage" : "SameAsEngage"});

SPLM.CAM.TurnEngageRetractBuilder.AutoOptions = Object.freeze({
    "UserDefinedValues" : "UserDefinedValues", "AutomaticValues" : "AutomaticValues", "ClearWallsByAngleAndDistance" : "ClearWallsByAngleAndDistance", "Withdraw" : "Withdraw", "WithdrawByDistance" : "WithdrawByDistance", "ClearWalls" : "ClearWalls", "ClearWallsByDistance" : "ClearWallsByDistance", "SameAsPlungeRetract" : "SameAsPlungeRetract"});

SPLM.CAM.TurnEngageRetractBuilder.ExtendMethods = Object.freeze({
    "Distance" : "Distance", "ToBlank" : "ToBlank"});

SPLM.CAM.TurnEngageRetractBuilder.DirectEngageRetractModes = Object.freeze({
    "None" : "None", "ToOrFromTrimPointOnly" : "ToOrFromTrimPointOnly", "Always" : "Always"});

export default SPLM;